import React from 'react';
import { toast } from 'react-toastify';
import { IntlShape, injectIntl } from 'react-intl';
import { StyledDivDialog } from 'containers/CourtManagerLegalProceedings/styled-components';
import DialogMission from 'containers/ExpertExpertise/Dialogs/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';

export interface SuspiciosClaimDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  claimId: number;
}

const SuspiciosClaimDialog: React.FC<SuspiciosClaimDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  /* istanbul ignore next */
  const successCallBack = () => {
    toast.success(translate(messages.suspiciousClaimToastSuccess, props));
    props.onClose();
  };

  /* istanbul ignore next */
  const onSubmit = () => {
    props.validateDialog(
      {
        id: props.claimId,
        claimInfo: { suspicious: true },
      },
      successCallBack,
    );
  };

  return (
    <DialogMission
      open={open}
      onClose={onClose}
      validateDialog={onSubmit}
      title={translate({ ...messages.suspiciousClaimTitle }, props)}
      content={
        <StyledDivDialog>
          {translate({ ...messages.suspiciousClaimDescription }, props)}
        </StyledDivDialog>
      }
      disabled={false}
    />
  );
};

SuspiciosClaimDialog.defaultProps = {
  open: false,
};

export default injectIntl(SuspiciosClaimDialog);
